export const assertNever = (input: never): never => input;
